import React, { useState } from 'react';
import c from 'classnames';

import { RecursiveMenu } from '@uncinc/react-drupal-core';

import DrawerMenuMenuItemLinkElement from './ItemLinkElement';
import DrawerMenuMenuItemWrapper from './ItemWrapper';

import './style.scss';

export interface DrawerMenuMenuProps {
  menuId: string;
  className?: string;
  onClickMenuLink?: () => void;
}

const DrawerMenuMenu: React.FC<DrawerMenuMenuProps> = (props) => {
  const { menuId, className, onClickMenuLink } = props;

  const [expandedMenuItem, setExpandedMenuItem] = useState('');

  const classNames = c('DrawerMenu__Menu', className);

  return (
    <div className={classNames}>
      <RecursiveMenu
        menuId={menuId}
        maxLevel={3}
        // @ts-expect-error
        MenuItemWrapper={DrawerMenuMenuItemWrapper}
        // @ts-expect-error
        MenuItemLinkElement={DrawerMenuMenuItemLinkElement}
        expandedMenuItem={expandedMenuItem}
        setExpandedMenuItem={setExpandedMenuItem}
        onClickFunction={() => {
          setExpandedMenuItem('');

          if (onClickMenuLink) {
            onClickMenuLink();
          }
        }}
      />
    </div>
  );
};

export default DrawerMenuMenu;
